import { render } from "./set-password-form.vue?vue&type=template&id=4e035e7e&scoped=true"
import script from "./set-password-form.vue?vue&type=script&setup=true&lang=js"
export * from "./set-password-form.vue?vue&type=script&setup=true&lang=js"

import "./set-password-form.vue?vue&type=style&index=0&id=4e035e7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e035e7e"],['__file',"src/views/auth/set-password-form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e035e7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e035e7e', __exports__)) {
    api.reload('4e035e7e', __exports__)
  }
  
  module.hot.accept("./set-password-form.vue?vue&type=template&id=4e035e7e&scoped=true", () => {
    api.rerender('4e035e7e', render)
  })

}


export default __exports__